<template>
  <div class="box is-clock-widget has-text-centered"
       style="margin-bottom: 0">
    <p class="subtitle is-4">{{new Date() | formatdate}}</p>
    <p class="title is-1">
      <span>{{hour}}</span>
      <span :class="blinkClass">:</span>
      <span>{{minute}}</span>
      <span :class="blinkClass">:</span>
      <span>{{second}}</span>
    </p>
  </div>
</template>

<script lang="ts">
  import {Vue, Component} from "annotation";

  @Component
  export default class DigitalClock extends Vue {

    public intervalSecond: any = null;

    public second: string = "00";

    public blinkClass: string = "";

    public minute: string = "00";

    public hour: string = "00";

    public mounted() {
      this.intervalSecond = setInterval(() => {
        let seconds = new Date().getSeconds();
        let minutes = new Date().getMinutes();
        let hours = new Date().getHours();

        this.second = seconds < 10 ? ("0" + seconds) : seconds.toString();
        this.minute = minutes < 10 ? ("0" + minutes) : minutes.toString();
        this.hour = hours < 10 ? ("0" + hours) : hours.toString();
        this.blinkClass = seconds % 2 === 0 ? 'opacity-0' : '';
      }, 1000);
    }

    public beforeDestroy() {
      clearInterval(this.intervalSecond);
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .is-clock-widget {
    background-color: $color-primary-young;
    margin-bottom: 0;

    p:first-child {
      color: $warning;
    }

    p, span {
      color: white;
    }

    p span {
      font-size: inherit;

      &:nth-child(even) {
        transition: .3s;
        margin: 0 .75rem;
      }
    }
  }
</style>
